<template>
    <textarea ref="tinyEditor"></textarea>
</template>

<script lang="ts">

import tinymce, { Editor } from  'tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/models/dom/model.js';
import 'tinymce/skins/ui/oxide/skin.min.css'

import 'tinymce/plugins/code';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';

import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class tinyEditor extends mixins(WithModel) {

    @Prop() height: number;

    editor: Editor;
    isTyping: boolean = false;
    checkerTimeout: any;

    @Watch('modelValue')
    onValueChange(next, prev){
        if(!this.isTyping && this.editor){
            this.editor.setContent(next);
        }
    }

    created(){
        if(this.modelValue == null || this.modelValue == undefined){
            this.localValue = "";
        }
    }

    toolbar1 = 'undo redo | formatselect | bold italic strikethrough  forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent  | removeformat | code';
    plugins = 'code lists link';
    mounted(){
        var options = {
            strict_loading_mode : true,
            target: this.$refs.tinyEditor as HTMLTextAreaElement,
            skin: false,
            height: this.height || 400,
            toolbar1: this.toolbar1,
            plugins: this.plugins,
            image_title: false,
            entity_encoding: "raw",
            setup: (editor) => {
                editor.on('keyUp', (e) => {
                    this.submitNewContent();
                });
                editor.on('change', (e) => {
                    if(this.editor.getContent() !== this.localValue){
                        this.submitNewContent();
                    }
                    this.$emit('editorChange', e);
                });
            }
        }

        tinymce.init(<any>options)
        .then(editors => {
            this.editor = editors[0];
            this.editor.setContent(this.localValue);
        });

    }

    submitNewContent(){
        this.isTyping = true;
        clearTimeout(this.checkerTimeout);
        this.checkerTimeout = setTimeout(()=>{
            this.isTyping = false;
        }, 100);

        this.emitModel(this.editor.getContent() || "")
    }

    beforeUnmount(){
        this.editor.destroy();
    }

}

</script>
<style scoped>

</style>
